import { ComponentPropsWithoutRef, ElementRef, forwardRef } from 'react';
import { Command } from 'cmdk';

import { cn } from 'styles';
import { SearchIcon } from '../Icons';

type CommandMenuInputProps = ComponentPropsWithoutRef<typeof Command.Input> & {
  containerClassName?: string;
};

export const CommandMenuInput = forwardRef<ElementRef<typeof Command.Input>, CommandMenuInputProps>(
  ({ className, containerClassName, ...props }, ref) => (
    <div
      className={cn('flex items-center border-b px-3', containerClassName)}
      // eslint-disable-next-line react/no-unknown-property
      cmdk-input-wrapper=""
    >
      <SearchIcon className="mr-2 h-4 w-4 shrink-0 opacity-50" />

      <Command.Input
        ref={ref}
        className={cn(
          'flex h-11 w-full rounded-md bg-transparent py-3 text-sm outline-none placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50',
          className,
        )}
        {...props}
      />
    </div>
  ),
);

CommandMenuInput.displayName = Command.Input.displayName;
